import { connect } from "react-redux";
import Valet from './valet'
import { bindActionCreators } from "redux";
import { valetList } from "services/redux/Valet/Supervisor/action";
import { updateValetStatus } from "services/redux/Valet/AddValet/action";

const mapStateToProps = (state) => ({
    siteInfo : state.CreateSupervisor.valetList,
    updateValetStatusDetails : state.CreateValet.updateValetStatus,
});

const mapDispatchToProps = (dispatch) =>
    bindActionCreators({
        valetList,
        updateValetStatus
    }, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(Valet);